'use client'

import { CircleX } from 'lucide-react'
import Image from 'next/image'
import { type ChangeEvent, type FormEvent, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { Input } from '@/components/ui/input'
import magnifyingGlass from '@/public/icons/magnifying-glass.svg'

interface SearchBarProps {
  isSearchVisible: boolean
  searchQuery: string
  termSearch: string
  onSearchChange: (value: string) => void
  onSearchFocus: () => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export function SearchBar({
  isSearchVisible,
  searchQuery,
  termSearch,
  onSearchChange,
  onSearchFocus,
  onSubmit,
}: SearchBarProps) {
  const [clearValueVisible, setClearValueVisible] = useState(false)

  function handleSearch(event: ChangeEvent<HTMLInputElement>) {
    onSearchChange(event.target.value)

    if (event.target.value) {
      setClearValueVisible(true)
    } else {
      setClearValueVisible(false)
    }
  }

  function handleClearValue() {
    onSearchChange('')
    setClearValueVisible(false)
  }

  return (
    <form
      className={twMerge(
        'mt-3 flex w-full flex-1 items-center rounded border border-gray-200 bg-transparent px-4 focus-within:border focus-within:border-primary-800 lg:mt-0',
        isSearchVisible && 'flex'
        // isLogged && 'bg-white md:w-lg'
      )}
      onSubmit={onSubmit}
    >
      <button type="submit">
        <Image
          alt="Ícone de uma lupa"
          height={20}
          src={magnifyingGlass}
          width={20}
        />
      </button>
      <Input
        className={twMerge(
          'border-transparent bg-transparent text-sm placeholder:text-gray-400 focus:border-transparent 2xl:w-75'
          // isLogged && 'min-w-full'
        )}
        onChange={handleSearch}
        onFocus={onSearchFocus}
        placeholder="Pesquisar"
        value={searchQuery ?? termSearch}
      />

      {clearValueVisible && (
        <button onClick={handleClearValue} type="button">
          <CircleX className="size-4 text-gray-600" />
        </button>
      )}
    </form>
  )
}
